import { Box, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import CreatePayment from './CreatePayment';
import PaymentHistory from './PaymentHistory';
import StickyEntity from '../Common/Entity/StickyEntity';

const Payment = () => {
  const { selectedSupplierData } = useSelector(
      (state) => state.entityReducer
  );
  const isEntityEnabled = selectedSupplierData?.entity_enabled;
  return (
    <>
      <StickyEntity />
      <Box sx={{ p: 2, mt: {xs : isEntityEnabled ? '96px': 0, md: 0 }, }}>
        <Grid
          container
          spacing={2}
          mb={3}

        >
          <Grid
            item
            xs={12}
          >
            <CreatePayment />
          </Grid>
            <Grid
            item
            xs={12}
          >
            <PaymentHistory />
          </Grid>
    
        </Grid>
      </Box>
    </>
  );
};

export default Payment;
